import { verifyUserQuery, updateUserLikeData, sendUserlike } from 'api'
import { v4 as randomUUID } from 'uuid'
import {
  SessionStorageKey,
  storage as sStorage,
  getUserlikeGroup,
  removeItem,
} from 'utils/sessionStorage'
import { storage as lStorage, LocalStorageKey } from 'utils/localStorage'

const checkUserlikeState = async () => {
  const lastUserId = sStorage.getItem(
    SessionStorageKey.SessionStorageLastUserKey
  )
  const userLikeIsEnabled = sStorage.getItem(
    SessionStorageKey.SessionStorageUserlike
  )

  if (userLikeIsEnabled) {
    let isLoggedIn = false

    try {
      const user = await verifyUserQuery()

      isLoggedIn = user?.isLoggedIn
    } catch (_) {} // eslint-disable-line no-empty

    const userLikeIdentifier = lStorage.getItem(
      LocalStorageKey.LocalStorageUserLikeIdKey
    )
    const userLikeContactId = lStorage.getItem(
      LocalStorageKey.LocalStorageUserLikeContactIdKey
    )

    if (isLoggedIn && !lastUserId && userLikeContactId) {
      await updateUserLikeData(userLikeContactId)
    } else if (!isLoggedIn && lastUserId && userLikeIdentifier) {
      await sendUserlike(
        userLikeIdentifier,
        'Diese Konversation wurde aufgrund der Abmeldung des Benutzers beendet.',
        getUserlikeGroup()
      )

      removeItem(SessionStorageKey.SessionStorageUserlike)
      removeItem(SessionStorageKey.SessionStorageUserlikeGroup)
      lStorage.setItem(LocalStorageKey.LocalStorageUserLikeIdKey, randomUUID())
      lStorage.removeItem(LocalStorageKey.LocalStorageUserLikeContactIdKey)
    }
  }
}

export default checkUserlikeState
